import {
    ICartGroup,
    ICartItem, IGroupsCheckedIds,
    ITraversedData,
    ICartItems,
} from 'mod/cart/interface';
import { CartItemType } from '@base/cart/interface'
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';

export function getGroupIndex(groups: ICartGroup[], groupId: string): number {
    return groups.findIndex(group => group.groupId === groupId);
}

/*
export function traverseGroups(groups: ICartGroup[], itemMap: ICartItemMap = {}): ITraversedData {
    const checkedIds: string[] = [];
    const instockIds: string[] = [];
    let totalQty = 0;

    const _groups = groups.map(group => {
        let stockCounter = 0;
        let selectCounter = 0;

        const items = group.cartItemList.map(originItem => {
            const item = { ...originItem, ...itemMap[originItem.id] };
            item.isChangingQty = item.isChangingQty || false;
            item.isDeleting = item.isDeleting || false;
            item.realNum = item.num;

            if (item.stockNum > 0) {
                stockCounter++;
                instockIds.push(item.id);
                if (item.select) {
                    selectCounter++;
                    checkedIds.push(item.id);
                    totalQty += item.num;
                }
            }

            return item;
        });

        return {
            ...group,
            cartItemList: items,
            groupCheckAll: selectCounter > 0 && selectCounter === stockCounter,
            groupLoading: group.groupLoading || false,
        }
    });

    return {
        groups: _groups,
        checkedIds,
        instockIds,
        checkAll: checkedIds.length === instockIds.length,
        totalQty,
    }
}
*/

// updateItems: Record<string, Partial<ICartItem>>
export function traverseItems(items: ICartItem[]): ITraversedData {
    const checkedIds: string[] = [];
    const instockIds: string[] = [];
    let totalQty = 0; //商品总数，包含未勾选项
    let checkedTotalQty = 0; //选中的商品总数

    Object.values(items).forEach(item => {
        if (item.stockNum > 0) {
            instockIds.push(item.id);
            totalQty += item.num;
            if (item.select) {
                checkedIds.push(item.id);
                checkedTotalQty += item.num;
            }
        }
    });

    return {
        checkAll: checkedIds.length === instockIds.length && instockIds.length > 0,
        totalQty,
        checkedTotalQty,
    }
}

export function getGroupItems(group: ICartGroup, items: ICartItem[]): ICartItem[] {
    return group.itemIds.map(id => items[id] as ICartItem);
}

export function isGroupEditable(group: ICartGroup): boolean {
    return group.groupType !== 'surpriseEgg';
}

export function isCheckAll(items: ICartItem[], checkedIds: string[]): boolean {
    if (checkedIds.length === 0) {
        return false;
    }
    for (const item of items) {
        if (item && item.stockNum > 0 && !checkedIds.includes(item.id)) {
            return false
        }
    }
    return true
}

export function getGroupsCheckedIds(groups: ICartGroup[], items: ICartItem[]): IGroupsCheckedIds {
    const groupMap: IGroupsCheckedIds = {};
    groups.forEach(group => {
        const groupItems = getGroupItems(group, items);
        groupMap[group.groupId] = groupItems.filter(item => item.stockNum > 0 && item.select).map(item => item.id);
    });
    return groupMap;
}

export function mergeGroupsCheckedIds(groupMap: IGroupsCheckedIds): string[] {
    const ids = [] as string[];
    Object.values(groupMap).forEach(groupItemsIds => {
        ids.push(...groupItemsIds);
    });
    return ids;
}

/**
 * 返回需要清除选中的组的groupIds（有不能选择的group 但组内的 cartItem 被选中了）
 * @param items
 */
export function getGroupNeedClearSelectedGroupIds(items: ICartItems): string[] | false {
    let groupIds: string[] = [];
    for (const itemId in items) {
        const item = items[itemId]
        if (!item.groupCanSelect
            && item.select
            && !groupIds.includes(item.groupId)
        ) {
            groupIds.push(item.groupId);
        }
    }

    if (groupIds.length > 0) {
        return groupIds;
    }
    return false;
}

/**
 * 该组cart商品是否全部为批量操作cart商品（selectStatus == 2）
 * @param groupItems
 */
export function isGroupAllItemSelectLinkage(groupItems: CartItemType[]) {
    // selectStatus == 2， 需联动勾选该组其他cartItem商品
    return !groupItems.find(item => item.selectStatus != 2);
}


export type IGetSelectedIdsParams = {
    e: CheckboxChangeEvent,
    groupCheckedIds: string[],
    item: ICartItem,
    groupItems: ICartItem[],
    batchActive: boolean, // 批量删除选择操作
}

/**
 * 获取当前购物车选中的ids
 * @param params
 */
export function getCartSelectedIds(
    params: IGetSelectedIdsParams
): string[] {
    const {
        e, groupCheckedIds, item, groupItems, batchActive
    } = params;

    const isChecked = e?.target?.checked
    const isLinkageItem = item.selectStatus == 2
    let selectedIds = groupCheckedIds

    if (!batchActive && isLinkageItem) {
        // 联动同组操作
        if (isChecked) {
            // 整组选中 排除无库存的
            selectedIds = groupItems
                .filter(_item => _item.stockNum > 0)
                .map((_item) => _item.id)
        } else {
            selectedIds = groupItems.filter((_item) => {
                // selectStatus 0 不排除
                return [0].includes(_item.selectStatus)
            }).map((_item) => _item.id)
        }
    } else {
        if (isChecked) {
            selectedIds = [...selectedIds, item.id]
        } else {
            selectedIds = selectedIds.filter((_id) => {
                return _id != item.id
            })
        }
    }

    return selectedIds;
}
